import React, { FC } from 'react';

import { IconProps } from 'types/components';

import Icon from './Icon';

const Search: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path d="M6.94 2.61a8 8 0 0 1 9.38 12.29l5.39 5.39a1 1 0 0 1-1.42 1.42l-5.38-5.39a8 8 0 1 1-8-13.71ZM10 4a6 6 0 1 0 6 6 6 6 0 0 0-6-6Z" />
  </Icon>
);

export default Search;
